import * as React from "react";
import { SubmitButtonProps } from "./typings";
import { UitkPrimaryButton, UitkButtonSize } from "uitk-react-button";
import { formatText } from "bernie-l10n";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";

export const SubmitButton: React.FunctionComponent<SubmitButtonProps> = ({ colSpan, lobState }) => (
  <UitkLayoutGridItem colSpan={colSpan}>
    <div>
      <UitkPrimaryButton
        tag="button"
        type="submit"
        text={formatText(lobState.config.form.submitButton.locToken)}
        size={UitkButtonSize.LARGE}
        isFullWidth={true}
      />
    </div>
  </UitkLayoutGridItem>
);
